document.addEventListener('DOMContentLoaded', function () {
  var body = document.body
  var miniCart = document.querySelector('#mini-cart')

  if (!miniCart) return

  function isMobile() {
    return window.matchMedia('(max-width: 989px)').matches
  }

  function getTooltipsWrap() {
    return document.querySelectorAll('.pd-tooltips-wrap')
  }

  function forceMiniCartFront() {
    miniCart.style.position = 'relative'
    miniCart.style.zIndex = '9999999'
  }

  function resetMiniCartFront() {
    miniCart.style.position = ''
    miniCart.style.zIndex = ''
  }

  function hideTooltipsWrap() {
    getTooltipsWrap().forEach(function (el) {
      if (!el.dataset.prevDisplay) {
        el.dataset.prevDisplay = el.style.display || ''
      }
      el.style.display = 'none'
    })
  }

  function showTooltipsWrap() {
    getTooltipsWrap().forEach(function (el) {
      el.style.display = el.dataset.prevDisplay || ''
      delete el.dataset.prevDisplay
    })
  }

  function openMiniCart() {
    if (!isMobile()) return
    body.classList.add('mini-cart-opened')
    forceMiniCartFront()
    hideTooltipsWrap()
  }

  function closeMiniCart() {
    if (!isMobile()) return
    body.classList.remove('mini-cart-opened')
    resetMiniCartFront()
    showTooltipsWrap()
  }

  function handleMiniCartState() {
    if (!isMobile()) {
      showTooltipsWrap()
      resetMiniCartFront()
      body.classList.remove('mini-cart-opened')
      return
    }

    if (miniCart.classList.contains('drawer--open')) {
      openMiniCart()
    } else {
      closeMiniCart()
    }
  }

  var observer = new MutationObserver(function () {
    handleMiniCartState()
  })

  observer.observe(miniCart, {
    attributes: true,
    attributeFilter: ['class']
  })

  window.addEventListener('resize', function () {
    handleMiniCartState()
  })

  miniCart.addEventListener('click', function (e) {
    if (
      e.target.closest('.drawer__overlay') ||
      e.target.closest('[data-action="close"]')
    ) {
      closeMiniCart()
    }
  })

  handleMiniCartState()
})
